import { FormSection } from 'components/form';
import { Typography, Box, Button } from '@mui/material';
import styles from './Confirm.module.scss';
import { useFormContext } from 'react-hook-form';
import { useEffect, useMemo } from 'react';
import { Done, Error, Replay } from '@mui/icons-material';
import { useFormState } from 'hooks/useFormState';

export function CreateDeviceModalConfirmSection() {
    const { watch } = useFormContext();

    const formSectionTitle = 'Confirm';

    // Manage the submit button state
    const {
        setIsFormSubmitDisabled,
        currentFormSectionIndex,
        formSections,
        setCurrentSectionIndex,
    } = useFormState();

    const [lastReading, estimatedTankLevelPct] = watch([
        'lastReading',
        'estimatedTankLevelPct',
    ]);

    const lastReadingTankLevelPct = lastReading?.tank
        ? Math.round(lastReading?.tank)
        : null;

    const isAccurateTankEstimate = useMemo(() => {
        const upperBound = Math.round(lastReading?.tank) + 6;
        const lowerBound = Math.round(lastReading?.tank) - 6;
        return (
            estimatedTankLevelPct <= upperBound &&
            estimatedTankLevelPct >= lowerBound
        );
    }, [lastReading?.tank, estimatedTankLevelPct]);

    useEffect(() => {
        if (
            currentFormSectionIndex === formSections.indexOf(formSectionTitle)
        ) {
            if (isAccurateTankEstimate) {
                setIsFormSubmitDisabled(false);
            } else {
                setIsFormSubmitDisabled(true);
            }
        }
    }, [
        setIsFormSubmitDisabled,
        currentFormSectionIndex,
        formSections,
        isAccurateTankEstimate,
    ]);

    const headerText =
        lastReadingTankLevelPct === null
            ? 'Go back and wait for reading'
            : isAccurateTankEstimate
            ? 'Dial matches estimate'
            : 'Dial does not match estimate';

    // NOTE Disable for now until monitor issue is fixed.
    // useEffect(() => {
    //     setValue('tankEstimateCorrect', isAccurateTankEstimate);
    //     setFormSectionError({
    //         section: 'Confirm',
    //         field: {
    //             name: 'tankEstimateCorrect',
    //             error: isAccurateTankEstimate,
    //         },
    //     });
    // }, [setFormSectionError, setValue, isAccurateTankEstimate]);

    const triggerRetry = () => {
        // set section index to the index of 'Tank Level' section
        const tankLevelSectionIndex = formSections.indexOf('Level Check');
        setCurrentSectionIndex(tankLevelSectionIndex);
    };

    return (
        <FormSection title={formSectionTitle}>
            <Box className={styles.header}>
                {lastReadingTankLevelPct !== null &&
                    (isAccurateTankEstimate ? (
                        <Done color="success" />
                    ) : (
                        <Error color="error" />
                    ))}
                <Typography variant="h6" sx={{ paddingLeft: '0.5rem' }}>
                    {headerText}
                </Typography>
            </Box>
            {lastReadingTankLevelPct !== null && !isAccurateTankEstimate && (
                <Box
                    // Stack child elements vertically
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Typography variant="body2">
                        Entered: {estimatedTankLevelPct}%
                        <br />
                        Actual: {lastReadingTankLevelPct}%
                        <br />
                        <br />
                        There may be an issue with the monitor&apos;s firmware
                        configuration, please contact administration if this
                        problem persists.
                        <br />
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={triggerRetry}
                        startIcon={<Replay />}
                        sx={{
                            // center this button horizontally
                            alignSelf: 'center',
                            margin: '1rem',
                        }}
                    >
                        Retry
                    </Button>
                </Box>
            )}
            {isAccurateTankEstimate && (
                <Typography sx={{ padding: '1rem' }}>
                    Please click next to continue the deployment process.
                </Typography>
            )}
        </FormSection>
    );
}
